import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { gql } from '@/__generated__/index.ts';

const DELETE_STREAM = gql(`
  mutation DeleteStream($id: ID!) {
    deleteStream(id: $id)
  }
`);

export const useDeleteStream = (id: string) => {
  const toast = useToast();

  const [deleteStreamMutation, result] = useMutation(DELETE_STREAM, {
    onCompleted: () => {
      toast.info({
        title: 'Stream successfully deleted',
      });
    },

    update(cache, result) {
      const updatedStream = result.data?.deleteStream;
      if (updatedStream) {
        cache.modify({
          fields: {
            streamsAll(existing, { readField }) {
              return {
                ...existing,
                items: existing.items.filter(
                  (itemRef: { __ref: string }) =>
                    readField('id', itemRef) !== id,
                ),
              };
            },
            streamsCreated(existing, { readField }) {
              return {
                ...existing,
                items: existing.items.filter(
                  (itemRef: { __ref: string }) =>
                    readField('id', itemRef) !== id,
                ),
              };
            },
          },
        });
        cache.modify({
          id: `Stream:${id}`,
          fields(_, { DELETE }) {
            return DELETE;
          },
        });
      }
    },
  });

  const deleteStream = () => {
    deleteStreamMutation({
      variables: {
        id,
      },
      optimisticResponse: {
        deleteStream: true,
      },
    });
  };

  return [deleteStream, result] as const;
};
